import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=f4748272&scoped=true"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"
import style0 from "./headers.vue?vue&type=style&index=0&id=f4748272&prod&lang=scss&scoped=true"
import style1 from "./headers.vue?vue&type=style&index=1&id=f4748272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4748272",
  null
  
)

export default component.exports